export default __webpack_public_path__ + "static/media/international_cat.77166a08.png";